export default {
	"e31734d7c1b1ece7e89c6f860438f113": "确认订单收银台-收银台浮层",
	"5d9d1694e5328a1e252676608ba51256": "支付金额",
	"035d0f9a012bbc74df08c66c8c32491b": "支付宝",
	"91b2ef6547c20214f5c1cfb548a9adab": "微信支付",
	"6048b9df0c43aeda0116eca3c6fcc969": "支付宝扫码付",
	"fe66e8c2346b3d606274bec0555c4734": "支付宝 | 先学后付"
}
